import { HistoryTerm } from '@empathy/search-types';
import { EmpathyXConfig, HistoryState } from '../../../models';
import { normalizeString } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { HISTORY_GETTERS_KEYS } from '../history.const';
import { HistoryGetter as HistoryGetterInterface } from '../history.interfaces';

export class QueryHistoryGetter implements HistoryGetterInterface {
  getters = {
    [HISTORY_GETTERS_KEYS.queryHistory]: (localState: HistoryState, getters: any, rootState: RootStoreState, rootGetters: any)
      : HistoryTerm[] => {
      const { history: config }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const inputQuery = rootState.core.inputQuery;
      const queryHistory = config.searchable && inputQuery
        ? localState.queryHistory.filter(this.searchForQuery(inputQuery))
        : localState.queryHistory;
      return queryHistory.slice(0, config.queryHistorySize);
    },
    [HISTORY_GETTERS_KEYS.version]: (): number => 3,
    [HISTORY_GETTERS_KEYS.storageKey]: (localState: HistoryState,
      getters: any): string => `history${ getters[HISTORY_GETTERS_KEYS.version] }`
  };

  protected searchForQuery(query: string): (suggestion: HistoryTerm) => boolean {
    const normalizedQuery = normalizeString(query);
    return (suggestion: HistoryTerm): boolean => {
      const normalizedSuggestion = normalizeString(suggestion.term);
      return normalizedSuggestion.includes(normalizedQuery) && normalizedSuggestion !== normalizedQuery;
    };
  }
}
